
define('template!textareaView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<textarea rows="4">' +
((__t = ( value )) == null ? '' : __t) +
'</textarea>';

}
return __p
};});

